<template>
  <!-- 信用批量申请页 -->
  <div class="credit-batch-application">
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="BATCH_SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>
    <a-card>
      <div class="text-right">
        <a-button @click="exportTable" type="primary" class="margin-right-20">
          导出
        </a-button>

        <!-- 新增批量申请modal -->
        <batch-upload-modal
          ref="batchUploadModal"
          btnText="获取账期信息"
          icon="plus"
          modal-title="获取账期信息"
          @ok="handleNewModalOk"
          @download="_downloadTemp"
          style="margin-right: 20px"
        />

        <limit-upload
          ref="LimitUpload"
          btnText="上传账期调整申请"
          icon="plus"
          modal-title="上传账期调整申请"
          @ok="handleLimitModalOk"
        />

      </div>
      <table-view
        bordered
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
      >
        <span slot="fileNameTitle">
          <a-tooltip>
            <template slot="title">
              下载文件可查看校验结果
            </template>
            <a-icon type="info-circle" />
            上传文件
          </a-tooltip>
        </span>

        <template v-slot:status="{ tableRow }">
          <a-tag
            :color="BATCH_STATUS_OBJ[tableRow.status].color"
            style="width: 80px; text-align: center;"
          >
            {{ BATCH_STATUS_OBJ[tableRow.status].label }}
          </a-tag>
        </template>
        <template v-slot:file="{ tableRow }">
          <a herf="javascript:;" @click="handleDownload(tableRow.id)">
            {{ tableRow.fileName }}
          </a>
        </template>
        <template v-slot:action="{ tableRow }">
          <a-button
            type="link"
            size="small"
            v-if="tableRow.status == 0"
            @click="handleBatchCheck(tableRow.id)"
          >
            验证
          </a-button>
          <a-button
            type="link"
            size="small"
            v-else-if="tableRow.status == 1"
            @click="toShowApproveModal(tableRow.id)"
          >
            审批
          </a-button>
          <a-button
            type="link"
            size="small"
            v-else-if="
              tableRow.status == 3 ||
                tableRow.status == 4 ||
                tableRow.status == 5
            "
            @click="toBatchDetailPage(tableRow.bpmId)"
          >
            查看
          </a-button>
        </template>
      </table-view>
    </a-card>

    <!-- 提交审批modal -->
    <a-modal
      title="提交审批"
      :visible="showApproveModal"
      :mask-closable="false"
      @ok="handleApproveModalOk"
      @cancel="handleApproveModalCancel"
      :confirm-loading="approveModalOkLoading"
      width="50%"
    >
      <a-form
        :form="approveForm"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
      >
        <!-- 选择审批人 -->
        <a-form-item label="账期调整审批人">
          <a-select
            allowClear
            showSearch
            style="width: 200px"
            option-filter-prop="children"
            v-decorator="$decorator('creditManager', '请选择账期调整审批人')"
          >
            <a-select-option
              v-for="manager in approvePersons"
              :key="manager.username"
            >
              {{ manager.name }} - {{ manager.username }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="申请原因及备注"
          required
          :help="remarkErr"
          :validate-status="remarkErr ? 'error' : 'success'"
        >
          <quill-editor :token="token" ref="quillEditor"></quill-editor>
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 跨级审批对话框 -->
    <cross-approve-modal
      :show-modal="showCrossModal"
      :action-loading="approveModalOkLoading"
      :cross-hint-msg="crossHintMsg"
      @onCrossSubmit="handleCrossSubmit"
      @onCloseCrossModal="handleCloseCrossModal"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import { BATCH_SEARCH_SCHEMA } from '../schema'
import {getLimitBatchList, getLimitApprovePersons, limitDownload, uploadCodeFile, check, batchLimit,
  getModelList, exportLists, getFreezeModelList, uploadLimitFile, getFreezeBgList, uploadPeriodCheck,
  downloadLimitBatchFile, getBusinessJsonList } from './api'
import { formatParamDate } from 'utils/util'
import { BATCH_STATUS_OBJ } from '../../const'
import { NEED_CROSS_APPROVAL, ERR_OK } from 'config/index'
//import MultiSelectApproval from '../../components/MultiSelectApproval.vue'
import QuillEditor from '../../components/QuillEditor.vue'
import CrossApproveModal from '../../components/CrossApproveModal.vue'
import BatchUploadModal from './BatchUploadModal.vue'
import LimitUpload from './LimitUpload.vue'
//import { data } from '@/views/client/client-center/detail/lengj-data/components/TAB1_REGURAR'

export default {
  name: 'period-batch-application',
  data() {
    const initSearchForm = {
      id: '',
      endTime: '',
      startTime: '',
      status: '',
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      BATCH_STATUS_OBJ,
      BATCH_SEARCH_SCHEMA,
      initSearchForm,
      searchForm,
      tableData: [],
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          align: 'center',
          fixed: 'left',
        },
        {
          title: '批量申请编号',
          dataIndex: 'id',
          align: 'center',
          width: 150,
        },
        {
          title: '申请数量',
          dataIndex: 'total',
          align: 'center',
          width: 100,
        },
        {
          title: '系统验证通过数量',
          dataIndex: 'success',
          align: 'center',
          width: 150,
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          align: 'center',
          width: 180,
        },
        {
          title: '系统验证时间',
          dataIndex: 'checkTime',
          align: 'center',
          width: 180,
        },
        {
          title: '提交审批时间',
          dataIndex: 'submitTime',
          align: 'center',
          width: 180,
        },
        {
          title: '操作人',
          dataIndex: 'operator',
          width: 120,
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'status' },
          align: 'center',
          width: 120,
        },
        {
          dataIndex: 'fileName',
          slots: { title: 'fileNameTitle' },
          scopedSlots: { customRender: 'file' },
          width: 220,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 100,
          fixed: 'right',
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableLoading: false,
      SCROLL: { x: 1500 },
      showApproveModal: false,
      approvalId: '', // 正在提交审批的id
      approveForm: this.$form.createForm(this, { name: 'approveForm' }),
      businessList: [], // 业务类型列表
      approvePersons: [],
      personErr: '',
      remarkErr: '',
      approveModalOkLoading: false,
      showCrossModal: false,
      crossHintMsg: '', // 跨级审批时后端返回的提示信息
      confirmSkipRemark: '',
      modelList: [],
      syList: [], //BG冻结
      moList: [], //业务模式冻结
      approve: [],
    }
  },
  computed: {
    ...mapGetters('user', ['token']),
  },
  mounted() {
    this._getBatchApplyList(this.initSearchForm)
    this._getBusinessJsonList()
    //this._getApprovePersons()
    this._getFreezeBgList()
  },
  methods: {

    //业务模式禁用
    handleModelFocus() {
      if (this.modelList) {
        this.modelList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.moList) {
        this.modelList.forEach(item => {
          this.moList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //刷新组件
      }
    },

    async _getBatchApplyList(searchForm) {
      if (this.tableLoading) {
        return
      }
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getLimitBatchList(formData)
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },

    async _getBusinessJsonList() {
      try {
        const { data } = await getBusinessJsonList()
        this.businessList = data
      } catch (error) {
        console.error(error)
      }
    },

    async _getFreezeBgList() {
      getFreezeBgList().then(({ data }) => {
        this.syList = data
      })
    },

    async _getApprovePersons(id) {
      try {
        const { data } = await getLimitApprovePersons(id)
        this.approvePersons = data
      } catch (error) {
        console.error(error)
      }
    },

    // 点击查询按钮
    handleSearch(data) {
      data = formatParamDate(data, data.applyRangeDate)
      delete data.applyRangeDate
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getBatchApplyList(data)
    },
    handlePagination(pagination) {
      ({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getBatchApplyList(this.searchForm)
    },
    // 点击链接下载
    handleDownload(id) {
      downloadLimitBatchFile(id)
    },
    async handleBatchCheck(id) {
      try {
        await check(id)
        this._getBatchApplyList(this.searchForm)
      } catch (error) {
        console.error(error)
      }
    },
    // 确认上传批量申请
    async handleNewModalOk(fileList) {
      if (fileList && fileList.length) {
        try {
          await uploadCodeFile({ file: fileList })
          this.handleNewModalCancel()
          this._getBatchApplyList(this.searchForm)
        } catch (error) {
          console.error(error)
        }
      } else {
        this.$notification.warning({
          message: '提示',
          description: '请上传文件',
        })
      }
    },
    // 确认上传批量申请
    async handleLimitModalOk(fileList) {
      if (fileList && fileList.length) {
        try {
          const { data } = await uploadPeriodCheck({ file: fileList })
          this.periodBo = data.aboolean
          //为标准账期
          if (this.periodBo == true) {
            await uploadLimitFile({ file: fileList })
            this.handleLimiModalCancel()
            this._getBatchApplyList(this.searchForm)
          } else if (this.periodBo == false){
            //非标准账期
            this.$confirm({
              title: '提示',
              content: '该账期非标准账期，是否继续?',
              okButtonProps: {
                loadings: this.loadings,
              },
              cancelText: '否',
              okText: '是',
              onOk: () => {
                this.loadings = true
                uploadLimitFile({ file: fileList })
                this.handleLimiModalCancel()
                this._getBatchApplyList(this.searchForm)
              },
            })
          }
          // await uploadLimitFile({ file: fileList })
          // this.handleLimiModalCancel()
          // this._getBatchApplyList(this.searchForm)
        } catch (error) {
          console.error(error)
        }
      } else {
        this.$notification.warning({
          message: '提示',
          description: '请上传文件',
        })
      }
    },
    handleNewModalCancel() {
      this.$refs.batchUploadModal.handleCancel()
    },
    handleLimiModalCancel() {
      this.$refs.LimitUpload.handleCancel()
    },
    // 下载模板
    _downloadTemp() {
      limitDownload()
    },

    toShowApproveModal(id) {
      this._getApprovePersons(id)
      this.approvalId = id
      this.showApproveModal = true
    },

    toBatchDetailPage(id) {
      this.$router.push({
        name: 'period-batch-approval-detail',
        params: { bpmId: id },
        query: { type: 8 },
      })
    },

    async validateForm() {
      const ap = await this.approveForm.validateFields()
      console.log(ap)
      const validateResult = {
        username: ap.creditManager,
      }
      console.log(validateResult)
      this.approve.push(validateResult)
      //const checkApprovalPersons = this.approve
      const checkQuillEditor = this.$refs.quillEditor.getContent().trim()
      try {
        this.personErr = this.approvePersons ? '' : '请添加审批人'
        this.remarkErr = checkQuillEditor ? '' : '请输入申请原因及备注'
        if ( this.approve && checkQuillEditor) {
          return Promise.resolve({
            remark: checkQuillEditor,
            approvePersons: this.approve,
            // attachmentIds,
          })
        } else {
          return Promise.resolve(false)
        }
      } catch (error) {
        console.error(error)
      }
    },

    /**
     * @param //confirmSkipStatus:跨级审批 1-跨级，其他-未跨级
     */
    async handleApproveModalOk() {
      const checkForm = await this.validateForm()
      if (!checkForm) {
        return
      }
      if (this.approveModalOkLoading) {
        return
      }
      const params = {
        id: this.approvalId,
        ...checkForm,
        //confirmSkip: Number(confirmSkipStatus) || 0,
        //confirmSkipRemark: confirmSkipStatus ? this.confirmSkipRemark : '',
      }
      console.log(params)
      this._batchApply(params)
    },

    async _batchApply(params) {
      this.approveModalOkLoading = true
      try {
        const { code, message } = await batchLimit(params)
        if (code == NEED_CROSS_APPROVAL) {
          // 需要跨级审批
          this.showCrossModal = true
          this.crossHintMsg = message
        } else if (code == ERR_OK) {
          this.handleApproveModalCancel()
          this._getBatchApplyList(this.searchForm)
        } else {
          this.$notification.warning({
            message: '提示',
            description: message,
          })
        }
        this.approveModalOkLoading = false
      } catch (error) {
        console.error(error)
      }
    },

    handleApproveModalCancel() {
      this.showApproveModal = false
      this.approvalId = ''
      this.approveForm.resetFields()
    },

    handleCrossSubmit(confirmSkipRemark) {
      this.confirmSkipRemark = confirmSkipRemark
      this.handleApproveModalOk(true)
    },
    handleCloseCrossModal() {
      this.showCrossModal = false
    },
    async changeBusiness(value) {
      this.approveForm.setFieldsValue({ modelId: '' })
      try {
        const { data } = await getModelList({ pid: value, type: 3 })
        this.modelList = data
        this._getFreezeModelList()
      } catch (err) {
        console.log(err)
      }
    },
    _getFreezeModelList() {
      getFreezeModelList().then(({ data }) => {
        this.moList = data
      })
    },
    exportTable() {
      const params = {
        ...this.searchForm,
      }
      exportLists(params)
    },
  },
  components: {
    SearchView,
    TableView,
   //MultiSelectApproval,
    QuillEditor,
    // Affix,
    CrossApproveModal,
    BatchUploadModal,
    LimitUpload,
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-form-explain {
  margin: 5px 0;
}
</style>
